import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgHourglassBig = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 120,
	height: 120,
	viewBox: "0 0 120 120",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_7850_501868)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M81 43C81.5523 43 82 43.4477 82 44C82 44.5523 81.5523 45 81 45H39C38.4477 45 38 44.5523 38 44C38 43.4477 38.4477 43 39 43H81Z",
				fill: "url(#paint0_linear_7850_501868)"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M59.5397 88.1123C59.8774 87.937 60.292 87.9669 60.6032 88.2021L81.7672 104.202C82.2077 104.535 82.2946 105.163 81.9616 105.604C81.6285 106.044 81.0016 106.131 80.5612 105.798L59.9967 90.251L39.2663 105.8C38.8244 106.131 38.1982 106.041 37.8668 105.6C37.5356 105.158 37.6253 104.532 38.067 104.2L59.4 88.2002L59.5397 88.1123Z",
				fill: "url(#paint1_linear_7850_501868)"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M60 60L44.0345 48.0259L31.5 38.625C31.0343 38.2757 30.6563 37.8228 30.3959 37.302C30.1355 36.7813 30 36.2072 30 35.625V18.75C30 17.7554 30.3951 16.8016 31.0984 16.0984C31.8016 15.3951 32.7554 15 33.75 15H86.25C87.2446 15 88.1984 15.3951 88.9017 16.0984C89.6049 16.8016 90 17.7554 90 18.75V35.4562C89.9982 36.0345 89.8627 36.6044 89.6041 37.1216C89.3455 37.6388 88.9709 38.0891 88.5094 38.4375L75.8319 48.0259L60 60Z",
				stroke: "#14151F",
				strokeWidth: 2,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M60 60L31.5 81.375C31.0343 81.7243 30.6563 82.1772 30.3959 82.6979C30.1355 83.2187 30 83.7928 30 84.375V101.25C30 102.245 30.3951 103.198 31.0984 103.902C31.8016 104.605 32.7554 105 33.75 105H86.25C87.2446 105 88.1984 104.605 88.9017 103.902C89.6049 103.198 90 102.245 90 101.25V84.5438C89.9996 83.964 89.8648 83.3921 89.6062 82.8732C89.3476 82.3543 88.9721 81.9024 88.5094 81.5531L60 60Z",
				stroke: "#14151F",
				strokeWidth: 2,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			})
		]
	}), /* @__PURE__ */ _jsxs("defs", { children: [
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint0_linear_7850_501868",
			x1: 38,
			y1: 45,
			x2: 39.7107,
			y2: 35.4358,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#6A64DE" }), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#E45D96"
			})]
		}),
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint1_linear_7850_501868",
			x1: 37.6669,
			y1: 106,
			x2: 77.6806,
			y2: 80.8632,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#6A64DE" }), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#E45D96"
			})]
		}),
		/* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_7850_501868",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 120,
				height: 120,
				fill: "white"
			})
		})
	] })]
});
export default SvgHourglassBig;
